<script>
  import { _, locale } from 'svelte-i18n';
  import { eventKeywordSetList } from '@store/keyword-store';
  import { resolveAudienceList } from '@app/utils/util';

  export let onChange;
</script>

<select name="audience" on:change="{onChange}" lang="{$locale}" aria-label="{$_('common.choose_audience')}">
  {#if $eventKeywordSetList.data[1]}
    <option value="">{$_('common.choose_audience')}</option>
    {#each resolveAudienceList($eventKeywordSetList.data, 'audience') as audience}
      <option value="{audience.id}" lang="{audience.name[$locale] ? $locale : 'fi'}">
        {audience.name[$locale] ? audience.name[$locale] : audience.name.fi}
      </option>
    {/each}
  {/if}
</select>

<style></style>